import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatOptionSelectionChange } from '@angular/material/core';
import { DataTypeComponent } from '../../../data-type-component';
import { FieldConfigDTO, SelectRuleDO } from '../../../../../../system/system-dtos';
import { BlastV2Service } from '../../../../../views/main-table-v2/service/blast-v2.service';

@Component({
  selector: 'app-form-field-rule',
  templateUrl: './rule-form-field.component.html',
  standalone: false,
})
export class RuleFormFieldComponent extends DataTypeComponent implements OnInit, OnDestroy {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  rowData: any;

  rules: SelectRuleDO[] = [];

  ruleData: any;

  selected: SelectRuleDO;

  fields: FieldConfigDTO[];

  selectedFieldConfig: FieldConfigDTO;

  ruleId: any;

  constructor(private blastService: BlastV2Service) {
    super();
  }

  ngOnInit() {
    this.blastService.getCollectionObservable('rules').subscribe((list) => {
      this.rules = list.sort((a: SelectRuleDO, b: SelectRuleDO) => {
        if (a.displayOrder > b.displayOrder) {
          return 1;
        }
        if (a.displayOrder < b.displayOrder) {
          return -1;
        }
        return 0;
      });

      if (this.data !== undefined && this.rowData !== undefined) {
        this.onRuleChange(
          this.data.rule ? this.data.rule : this.data,
          new MatOptionSelectionChange(null, true),
          this.rowData.ruleData
        );
      }
    });
  }

  onRuleChange(rule: SelectRuleDO, $event: MatOptionSelectionChange, ruleData) {
    if (!$event.isUserInput || (this.selected && rule.id === this.selected.id)) {
      return;
    }
    this.selected = rule;
    this.formGroup.get(this.fieldConfig.name).setValue(this.selected);
    this.ruleId = rule ? rule.id : null;

    this.fields = [];
    if (this.selected && this.selected.formConfig) {
      this.selected.formConfig.forEach((row) => {
        row.columns.forEach((column) => {
          column.fields.forEach((f) => {
            this.fields.push(f);
          });
        });
      });
    }

    if (ruleData !== undefined && !(Object.keys(ruleData).length === 0 && ruleData.constructor === Object)) {
      this.ruleData = ruleData;
    } else {
      this.ruleData = rule.dataTemplate;
    }
    this.selectedFieldConfig = { name: 'ruleData', label: 'Criteria', type: 'criteria' } as FieldConfigDTO;
    this.selectedFieldConfig.innerFields = this.fields;
  }

  setRowData(entity: any) {
    this.rowData = entity;
    if (this.data !== undefined && this.rowData !== undefined) {
      this.onRuleChange(
        this.data.rule ? this.data.rule : this.data,
        new MatOptionSelectionChange(null, true),
        this.rowData.ruleData
      );
    }
  }

  ngOnDestroy() {}
}
